export const firstNonBlank = (...values) => {
    for (const value of values) {
        if (value === null || value === undefined) continue;

        const normalized = String(value).trim();
        if (normalized) return normalized;
    }

    return '';
};

export const getContactDocumentName = (contact = {}, fallback = '-') => (
    firstNonBlank(
        contact.company_name,
        contact.supplier_company,
        contact.name,
        contact.contact_name,
        contact.supplier_name,
        contact.customer_name,
        fallback
    ) || fallback
);
